import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1413ecc2&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413ecc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1413ecc2')) {
      api.createRecord('1413ecc2', component.options)
    } else {
      api.reload('1413ecc2', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1413ecc2&scoped=true&", function () {
      api.rerender('1413ecc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B94e5pSPe1yx/JS/comp/SearchFilterTokens.vue"
export default component.exports